import { type SyntheticEvent, useState } from 'react';
import InputCheckbox from '../../../../../components/forms/InputCheckbox';
import Modal from '../../../../../components/modals/Modal';
import QuestionTags from '../../questions-summary-list/question-item/QuestionTags';
import EditCard from '../EditCard';
import type {
	Category,
	Question as IQuestion
} from '../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../data/interface-question-bank';

interface QuestionProps {
	categories: Category[];
	question: IQuestion;
	questionBankID: QuestionBankID;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}

const ViewEditTags = ({
	categories,
	question,
	questionBankID,
	onUpdate
}: QuestionProps) => {
	const [edit, setEdit] = useState(false);
	const [tags, setTags] = useState<string[]>([]);

	const handleUpdate = () => {
		onUpdate(question.id, 'tags', tags)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	const handleTags = (e: SyntheticEvent) => {
		const target = e.target as HTMLInputElement;
		const { id } = target;
		const tagsArray: string[] = tags.length > 0 ? [...tags] : [];

		if (tags.includes(id)) {
			const index = tagsArray.indexOf(id);
			tagsArray.splice(index, 1);
			setTags([...tagsArray]);
		} else {
			tagsArray.push(id);
			setTags([...tagsArray]);
		}
	};

	return (
		<>
			<EditCard label='Tags' onEdit={setEdit}>
				<QuestionTags categories={categories} tags={question.tags} />
			</EditCard>

			<Modal
				actionBtnText='Agregar'
				handleAction={handleUpdate}
				headline='Tags'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				{/* CATEGORY SELECTIONS */}
				<div className='my-2'>
					<div className='grid grid-cols-3 gap-1'>
						{categories
							.filter((c) => c.questionBank === questionBankID)
							.map((c) => {
								return (
									<InputCheckbox
										key={c.id}
										id={c.id}
										isChecked={tags.includes(c.id)}
										label={c.name}
										parentClass='relative inline-flex items-start my-1 2xl:w-full w-1/2'
										handleChange={handleTags}
									/>
								);
							})}
					</div>
				</div>
			</Modal>
		</>
	);
};
export default ViewEditTags;
